module.exports = __webpack_public_path__ + "img/interests-building.e408c157.png";